import React, { useState } from "react";
import Auth from "../../components/Auth/Auth";
import gmail from "../../assets/images/gmail.png";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { emailSent } from "../../features/slices/authReducer";
const intialState = {
  email: "",
  errors: {},
  loading: false,
};
const ForgetPassword = () => {
  const [iState, updateState] = useState(intialState);
  const { email, loading, errors } = iState;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const validateEmail = (email) => {
    if (!email) {
      return "Email is required";
    } else if (!/^.+?@.+?\..+$/.test(email)) {
      return "This must be a valid email address";
    }
    return null;
  };

  const handleInputChange = (e) => {
    updateState({ ...iState, [e.target.name]: e.target.value, errors: {} });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const emailError = validateEmail(email);
    if (emailError) {
      updateState({ ...iState, errors: { email: emailError } });
      return;
    } else {
      updateState({ ...iState, loading: true, errors: {} });
      dispatch(emailSent({ email })).then((data) => {
        if (data?.payload?.code === 200) {
          updateState({ ...iState, loading: false });
          navigate("/SendEmail", { state: { email } });
        } else {
          updateState({ ...iState, loading: false });
        }
      });
    }
  };
  return (
    <Auth>
      <h2>Forget Password</h2>
      <h6>Enter your registered email below</h6>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Email Address"
            name="email"
            value={email}
            onChange={handleInputChange}
          />
          <span className="Icon">
            <img src={gmail} />
          </span>
          {errors.email && (
            <p
              className="text-start text-danger mt-2"
              style={{
                textAlign: "start",
              }}
            >
              {errors.email}
            </p>
          )}
        </div>
        {/* <button class="Button">Send OTP</button>  */}
        <button
          type="submit"
          className="Button"
          style={{
            width: "100%",
          }}
          disabled={loading}
        >
          Submit
        </button>
        <div className="Checkboxs">
          <p className="BackToLogin">
            Back to <Link to={"/login"}>Sign In</Link>
          </p>
        </div>
      </form>
    </Auth>
  );
};

export default ForgetPassword;
